module.exports = __webpack_public_path__ + "d237576a02c3ad5c7f58a58fd9be6c30.MP3";